import { Lesson } from "@jelly/lesson";
import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "b30b5dcc-39ea-465b-81a7-f0ce0e493af3",
  publicId: "30",
  name: "Practical approaches for innovative, sustainable and cost-effective buildings",
  difficulty: 2,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, principle02, task01],
};

export default lesson;
